module.exports = __webpack_public_path__ + "img/dragonhawk_portal_small.84f8053e.png";